import { render, staticRenderFns } from "./BaseTableReportHistoryTable.vue?vue&type=template&id=f36942f8&scoped=true"
import script from "./BaseTableReportHistoryTable.vue?vue&type=script&lang=js"
export * from "./BaseTableReportHistoryTable.vue?vue&type=script&lang=js"
import style0 from "./BaseTableReportHistoryTable.vue?vue&type=style&index=0&id=f36942f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f36942f8",
  null
  
)

export default component.exports